import { render, staticRenderFns } from "./project-economic-preview.vue?vue&type=template&id=4e5bac6f"
import script from "./project-economic-preview.vue?vue&type=script&lang=js"
export * from "./project-economic-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports